import __request__ from "routing/request";
export function getOverview() {
  return __request__("GET", "/authz/grants-overview", null, {}, {
    "Accept": ["application/json"]
  });
}
